import DeductibleReductionStep from "components/steps/DeductibleReductionStep";

const FavPlanDeductibleReductionStep = () => <DeductibleReductionStep />;

export default FavPlanDeductibleReductionStep;
